import { useContext } from 'react';
import { UserContext } from '../context/CurrentUser';

const useCurrentUser = () => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useCurrentUser must be used within a UserProvider');
  }
  return context;
};

export default useCurrentUser;
